import { render } from "./ExtraQuestionTicketPaywall.vue?vue&type=template&id=45bce4e3&scoped=true"
import script from "./ExtraQuestionTicketPaywall.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionTicketPaywall.vue?vue&type=script&lang=js"

import "./ExtraQuestionTicketPaywall.vue?vue&type=style&index=0&id=45bce4e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bce4e3"]])

export default __exports__